const challengeSection = document.querySelector("#challenge");
const challengeForm = document.querySelector("#challengeForm");
const playerName = document.querySelector("#playerName");
const eventInputs = [
  document.querySelector("#squareScore"),
  document.querySelector("#fieldScore"),
  document.querySelector("#buntScore"),
  document.querySelector("#groundScore"),
  document.querySelector("#deepScore"),
];
const challengeTotal = document.querySelector("#challengeTotal");
const challengeRank = document.querySelector("#challengeRank");
const challengeMessage = document.querySelector("#challengeMessage");
const leaderboardBody = document.querySelector("#leaderboardBody");
const leaderboardSearch = document.querySelector("#leaderboardSearch");
const leaderboardSearchStatus = document.querySelector("#leaderboardSearchStatus");
const refreshBoardButton = document.querySelector("#refreshBoardButton");
const scoreSubmitButton = challengeForm.querySelector("[type='submit']");
const scoreHoneypot = challengeForm.querySelector("[name='website']");
const leaderboardApiUrl = challengeSection.dataset.leaderboardApiUrl;
const playerIdKey = "solopop-shared-player-id-v1";
const reviewTickerTrack = document.querySelector(".review-ticker-track");
const reviewTickerGroup = document.querySelector(".review-ticker-group");
const customerVideos = document.querySelectorAll(".customer-video-slide video");
const customerVideoCarousel = document.querySelector(".customer-video-carousel");
const customerVideoSlides = [...document.querySelectorAll("[data-customer-video-slide]")];
const customerVideoSwitches = [...document.querySelectorAll("[data-customer-video-target]")];
const hitterSkillGrid = document.querySelector("#hitterSkillGrid");
const quickCheckoutButtons = document.querySelectorAll("[data-quick-checkout]");
let leaderboardEntries = [];
let leaderboardTotalPlayers = 0;
let leaderboardLoading = true;
let leaderboardError = "";
let loadedSearchQuery = "";
let boardSearchTimer;
let boardRequestNumber = 0;
let memoryPlayerId = "";

const hitterSkills = [
  {
    number: "01",
    accent: "red",
    player: "Tony Gwynn",
    achievement: "8 batting titles · .338 career average",
    title: "Hit the ball cleanly over and over.",
    story: "Tony Gwynn won eight batting titles and finished his 20-year career with a .338 average. He struck out only 434 times, yet he also hit 543 doubles, so his contact was not simply soft. Gwynn studied video, adjusted his swing, and became dangerous down either line and through the middle. Pitchers had very few safe places to attack him.",
    baseballReason: "That is what coaches mean by repeatable contact: see the ball clearly, meet it cleanly, and send a low line drive through the defence. A ball through the middle reaches the outfield quickly and gives the pitcher, shortstop, and second baseman very little time to react.",
    gameUse: "Drive a line ball through the middle before the pitcher, shortstop, or second baseman can react.",
    diagram: "square",
  },
  {
    number: "02",
    accent: "green",
    player: "Freddie Freeman",
    achievement: "Three 48-ball buckets · left, centre, choice",
    title: "Send the ball where you choose.",
    story: "As a young player, Freddie Freeman practised with his father at least five days a week for much of a decade. He hit one 48-ball bucket toward left field, one toward centre, and a third wherever he chose. Freeman even preferred practising on a field because he wanted to see exactly where every ball went. Years later, his manager still praised his ability to let the pitch travel and hit it all over the field.",
    baseballReason: "Direction is a decision, not an accident. Meet the ball a little earlier to send it toward the pull side, let it travel slightly longer for the opposite field, or meet it squarely to drive it through the centre. A hitter who can use all three areas is much harder to defend.",
    gameUse: "Use an outside pitch toward the opposite field, drive a middle pitch through centre, or pull an inside pitch. The defence cannot protect every area equally.",
    diagram: "directional",
  },
  {
    number: "03",
    accent: "gold",
    player: "Ichiro Suzuki",
    achievement: "262 hits in 2004 · 694 estimated infield hits",
    title: "Put the ball where the defence has a difficult play.",
    story: "Ichiro Suzuki set the Major League single-season record with 262 hits in 2004 and finished his career with an estimated 694 infield hits. He did not need every hit to be hard or deep. A well-placed bunt or ground ball forced a defender to charge, move sideways, field it cleanly, and make a fast throw. Ichiro's speed finished the play, but the first advantage came from choosing open space and keeping the ball low.",
    baseballReason: "Coaches value hitters who can change the play when the situation demands it. Practise dropping a soft bunt down either line, then practise sending a firmer ground ball between two infielders. The goal is not random contact; it is making the defence handle the ball in the most difficult place.",
    gameUse: "Move a runner with a controlled bunt, force a corner infielder to charge, or send a ground ball between two defenders and into the outfield.",
    diagram: "placement",
  },
  {
    number: "04",
    accent: "navy",
    player: "Albert Pujols",
    achievement: "2,218 career RBIs · 123 sacrifice flies",
    title: "Drive the ball deep enough to bring the runner home.",
    story: "Albert Pujols drove in 2,218 runs, the second-highest total in Major League history, and hit 123 sacrifice flies. One clear example came in 2022: with the winning runner on third in extra innings, Pujols drove the ball deep into left field for a walk-off sacrifice fly. His team did not need a home run. It needed a ball hit far enough for the runner to score after the catch.",
    baseballReason: "A shallow fly is caught close to the infield, where the throw home is short. A deeper fly makes the outfielder retreat and gives the runner more time to leave third and beat the throw. A straight-up popup creates neither distance nor time.",
    gameUse: "With a runner on third and fewer than two outs, a deep fly can bring the runner home even when the batter is out.",
    diagram: "carry",
  },
];

function renderFieldBackdrop(id) {
  return `
    <defs>
      <linearGradient id="${id}-grass" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="#2f7046"></stop>
        <stop offset="100%" stop-color="#174d33"></stop>
      </linearGradient>
      <pattern id="${id}-stripes" width="52" height="52" patternUnits="userSpaceOnUse" patternTransform="rotate(22)">
        <rect width="26" height="52" fill="rgba(255,255,255,.035)"></rect>
      </pattern>
      <marker id="${id}-arrow" markerWidth="22" markerHeight="22" refX="19" refY="11" orient="auto" markerUnits="userSpaceOnUse" viewBox="0 0 22 22">
        <path class="diagram-arrowhead" d="M0 0L22 11L0 22Z"></path>
      </marker>
      <marker id="${id}-run-arrow" markerWidth="14" markerHeight="14" refX="12" refY="7" orient="auto" markerUnits="userSpaceOnUse" viewBox="0 0 14 14">
        <path class="diagram-run-arrowhead" d="M0 0L14 7L0 14Z"></path>
      </marker>
    </defs>
    <rect class="diagram-field-frame" x="5" y="5" width="550" height="330" rx="8"></rect>
    <path class="diagram-outfield" fill="url(#${id}-grass)" d="M280 310L26 78Q280 -22 534 78Z"></path>
    <path class="diagram-grass-stripes" fill="url(#${id}-stripes)" d="M280 310L26 78Q280 -22 534 78Z"></path>
    <path class="diagram-outfield-fence" d="M26 78Q280 -22 534 78"></path>
    <path class="diagram-foul-line" d="M280 304L28 78M280 304L532 78"></path>
    <path class="diagram-infield-dirt" d="M280 307L386 210L280 112L174 210Z"></path>
    <path class="diagram-infield-grass" d="M280 282L360 210L280 138L200 210Z"></path>
    <path class="diagram-basepath" d="M280 296L370 210L280 124L190 210Z"></path>
    <circle class="diagram-mound" cx="280" cy="213" r="15"></circle>
    <circle class="diagram-rubber" cx="280" cy="213" r="3"></circle>
    <rect class="diagram-base" x="364" y="204" width="12" height="12" transform="rotate(45 370 210)"></rect>
    <rect class="diagram-base" x="274" y="118" width="12" height="12" transform="rotate(45 280 124)"></rect>
    <rect class="diagram-base" x="184" y="204" width="12" height="12" transform="rotate(45 190 210)"></rect>
    <path class="diagram-home" d="M272 295H288V303L280 310L272 303Z"></path>
  `;
}

function renderDrillDiagram(type) {
  const diagrams = {
    square: `
      <svg viewBox="0 0 560 340" role="img" aria-label="Baseball field showing a line drive travelling from home plate through the middle">
        <title>Line drive through the middle</title>
        ${renderFieldBackdrop("square-field")}
        <circle class="diagram-defender" cx="280" cy="213" r="9"></circle>
        <circle class="diagram-defender" cx="236" cy="169" r="10"></circle>
        <circle class="diagram-defender" cx="324" cy="169" r="10"></circle>
        <rect class="diagram-target" x="246" y="64" width="68" height="48" rx="4"></rect>
        <path class="diagram-path-halo" d="M280 290Q280 198 280 106"></path>
        <path class="diagram-success" d="M280 290Q280 198 280 106" marker-end="url(#square-field-arrow)"></path>
        <circle class="diagram-contact" cx="280" cy="289" r="6"></circle>
        <g class="diagram-label-chip" transform="translate(178 20)">
          <rect width="204" height="30" rx="4"></rect>
          <text x="102" y="20" text-anchor="middle">LINE DRIVE THROUGH THE MIDDLE</text>
        </g>
      </svg>
    `,
    directional: `
      <svg viewBox="0 0 560 340" role="img" aria-label="Baseball field showing arrows from home plate to left, centre, and right field">
        <title>Hit to left, centre, or right field</title>
        ${renderFieldBackdrop("direction-field")}
        <path class="diagram-field-zone" d="M280 300L31 79Q148 20 234 8Z"></path>
        <path class="diagram-field-zone" d="M280 300L234 8Q280 -5 326 8Z"></path>
        <path class="diagram-field-zone" d="M280 300L326 8Q412 20 529 79Z"></path>
        <circle class="diagram-defender" cx="103" cy="92" r="10"></circle>
        <circle class="diagram-defender" cx="310" cy="56" r="10"></circle>
        <circle class="diagram-defender" cx="457" cy="92" r="10"></circle>
        <path class="diagram-path-halo" d="M274 291Q221 193 132 103M280 291Q280 176 280 68M286 291Q339 193 428 103"></path>
        <path class="diagram-success" d="M274 291Q221 193 132 103M280 291Q280 176 280 68M286 291Q339 193 428 103" marker-end="url(#direction-field-arrow)"></path>
        <circle class="diagram-contact" cx="280" cy="289" r="6"></circle>
        <g class="diagram-label-chip" transform="translate(73 37)">
          <rect width="82" height="28" rx="4"></rect>
          <text x="41" y="19" text-anchor="middle">LEFT</text>
        </g>
        <g class="diagram-label-chip" transform="translate(235 13)">
          <rect width="90" height="28" rx="4"></rect>
          <text x="45" y="19" text-anchor="middle">CENTRE</text>
        </g>
        <g class="diagram-label-chip" transform="translate(405 37)">
          <rect width="82" height="28" rx="4"></rect>
          <text x="41" y="19" text-anchor="middle">RIGHT</text>
        </g>
      </svg>
    `,
    placement: `
      <svg viewBox="0 0 560 340" role="img" aria-label="Baseball field showing short bunt paths down both lines and a ground ball through the infield gap">
        <title>Place a bunt down either line or a ground ball through the gap</title>
        ${renderFieldBackdrop("placement-field")}
        <circle class="diagram-defender" cx="190" cy="207" r="10"></circle>
        <circle class="diagram-defender" cx="370" cy="207" r="10"></circle>
        <circle class="diagram-defender" cx="238" cy="163" r="10"></circle>
        <circle class="diagram-defender" cx="322" cy="163" r="10"></circle>
        <path class="diagram-path-halo" d="M273 292Q237 258 200 224M287 292Q323 258 360 224M280 290Q271 235 280 191Q285 146 280 103"></path>
        <path class="diagram-bunt-path" d="M273 292Q237 258 200 224M287 292Q323 258 360 224" marker-end="url(#placement-field-arrow)"></path>
        <path class="diagram-success" d="M280 290Q271 235 280 191Q285 146 280 103" marker-end="url(#placement-field-arrow)"></path>
        <path class="diagram-bounce" d="M268 250Q280 238 292 250M268 205Q280 193 292 205"></path>
        <circle class="diagram-contact" cx="280" cy="289" r="6"></circle>
        <g class="diagram-label-chip is-small" transform="translate(104 234)">
          <rect width="92" height="28" rx="4"></rect>
          <text x="46" y="19" text-anchor="middle">BUNT</text>
        </g>
        <g class="diagram-label-chip is-small" transform="translate(364 234)">
          <rect width="92" height="28" rx="4"></rect>
          <text x="46" y="19" text-anchor="middle">BUNT</text>
        </g>
        <g class="diagram-label-chip" transform="translate(179 40)">
          <rect width="202" height="30" rx="4"></rect>
          <text x="101" y="20" text-anchor="middle">GROUND BALL THROUGH GAP</text>
        </g>
      </svg>
    `,
    carry: `
      <svg viewBox="0 0 560 340" role="img" aria-label="Baseball field showing a deep fly ball and a runner travelling from third base to home">
        <title>Deep fly ball gives the runner time to score</title>
        ${renderFieldBackdrop("carry-field")}
        <circle class="diagram-defender" cx="238" cy="83" r="11"></circle>
        <path class="diagram-distance-line" d="M72 112Q280 31 488 112"></path>
        <path class="diagram-path-halo" d="M280 290Q238 146 205 95"></path>
        <path class="diagram-success" d="M280 290Q238 146 205 95" marker-end="url(#carry-field-arrow)"></path>
        <circle class="diagram-runner" cx="190" cy="210" r="10"></circle>
        <path class="diagram-run" d="M190 222Q205 273 267 300" marker-end="url(#carry-field-run-arrow)"></path>
        <circle class="diagram-contact" cx="280" cy="289" r="6"></circle>
        <g class="diagram-label-chip" transform="translate(137 28)">
          <rect width="138" height="30" rx="4"></rect>
          <text x="69" y="20" text-anchor="middle">DEEP FLY BALL</text>
        </g>
        <g class="diagram-label-chip is-gold" transform="translate(68 253)">
          <rect width="138" height="30" rx="4"></rect>
          <text x="69" y="20" text-anchor="middle">RUNNER SCORES</text>
        </g>
      </svg>
    `,
  };

  return diagrams[type] || "";
}

function renderHitterSkillCard(skill) {
  const cardId = `hitter-skill-${skill.number}`;

  return `
    <article class="hitter-skill-card skill-accent-${skill.accent}" aria-labelledby="${cardId}">
      <header class="skill-player-line">
        <span class="skill-card-number">${skill.number}</span>
        <span class="skill-player-copy"><strong>${skill.player}</strong><span>${skill.achievement}</span></span>
      </header>
      <h3 class="skill-practice-title" id="${cardId}">${skill.title}</h3>
      <p class="skill-story">${skill.story}</p>
      <p class="skill-reason">${skill.baseballReason}</p>
      <div class="skill-diagram">${renderDrillDiagram(skill.diagram)}</div>
      <p class="practice-game-use"><strong>When it helps in a game</strong><span>${skill.gameUse}</span></p>
    </article>
  `;
}

function renderHitterSkills() {
  if (!hitterSkillGrid) return;
  hitterSkillGrid.innerHTML = hitterSkills.map(renderHitterSkillCard).join("");
}

function clampScore(value) {
  const score = Number(value);
  if (!Number.isFinite(score)) return 0;
  return Math.min(Math.max(Math.round(score), 0), 10);
}

function rankForTotal(total) {
  if (total >= 43) return "MVP";
  if (total >= 31) return "All-Star";
  if (total >= 16) return "Starter";
  return "Rookie";
}

function currentScores() {
  return eventInputs.map((input) => clampScore(input.value));
}

function updateChallengeTotal() {
  const total = currentScores().reduce((sum, score) => sum + score, 0);
  challengeTotal.textContent = `${total}/50`;
  challengeRank.textContent = rankForTotal(total);
  return total;
}

function escapeHtml(value) {
  return String(value).replace(/[&<>'"]/g, (character) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "'": "&#39;",
    '"': "&quot;",
  })[character]);
}

function createPlayerId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();

  const bytes = new Uint8Array(16);
  globalThis.crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

function getPlayerId() {
  if (memoryPlayerId) return memoryPlayerId;

  try {
    const savedPlayerId = localStorage.getItem(playerIdKey);
    if (savedPlayerId) {
      memoryPlayerId = savedPlayerId;
      return memoryPlayerId;
    }
  } catch {
    // A temporary in-memory ID still lets private-browsing sessions post a score.
  }

  memoryPlayerId = createPlayerId();
  try {
    localStorage.setItem(playerIdKey, memoryPlayerId);
  } catch {
    // Keep the generated ID in memory when browser storage is unavailable.
  }
  return memoryPlayerId;
}

function normalizedBoardEntries() {
  return leaderboardEntries
    .filter((entry) =>
      entry &&
      typeof entry.name === "string" &&
      Array.isArray(entry.scores) &&
      entry.scores.length === 5
    )
    .map((entry, index) => {
      const scores = entry.scores.map(clampScore);
      const total = scores.reduce((sum, score) => sum + score, 0);
      return {
        name: entry.name,
        scores,
        total,
        place: Number.isInteger(entry.place) ? entry.place : index + 1,
        rank: typeof entry.rank === "string" ? entry.rank : rankForTotal(total),
      };
    });
}

function playerCountLabel(count) {
  return `${count} ${count === 1 ? "player" : "players"}`;
}

function renderBoard() {
  const entries = normalizedBoardEntries();
  const searchTerm = leaderboardSearch.value.trim();
  const normalizedSearchTerm = searchTerm.toLocaleLowerCase("en-CA");
  const searchResultsAreCurrent = normalizedSearchTerm === loadedSearchQuery.toLocaleLowerCase("en-CA");
  const visibleEntries = normalizedSearchTerm && !searchResultsAreCurrent
    ? entries.filter((entry) => entry.name.toLocaleLowerCase("en-CA").includes(normalizedSearchTerm))
    : entries;

  refreshBoardButton.disabled = leaderboardLoading;
  refreshBoardButton.textContent = leaderboardLoading ? "Loading..." : "Refresh scores";

  if (leaderboardLoading && !entries.length) {
    leaderboardBody.innerHTML = '<tr class="empty-board"><td colspan="7">Loading live scores...</td></tr>';
    leaderboardSearchStatus.textContent = normalizedSearchTerm ? "Searching the live board." : "Loading the live board.";
    return;
  }

  if (leaderboardError && !entries.length) {
    leaderboardBody.innerHTML = '<tr class="empty-board"><td colspan="7">Live scores are temporarily unavailable. Refresh to try again.</td></tr>';
    leaderboardSearchStatus.textContent = leaderboardError;
    return;
  }

  if (!entries.length && !normalizedSearchTerm) {
    leaderboardBody.innerHTML = '<tr class="empty-board"><td colspan="7">No scores yet. Be first on the board.</td></tr>';
    leaderboardSearchStatus.textContent = "No players have posted a score yet.";
    return;
  }

  if (!visibleEntries.length) {
    leaderboardBody.innerHTML = `<tr class="empty-board"><td colspan="7">No player matches "${escapeHtml(searchTerm)}".</td></tr>`;
    leaderboardSearchStatus.textContent = `No player matches ${searchTerm}.`;
    return;
  }

  leaderboardSearchStatus.textContent = normalizedSearchTerm
    ? `${visibleEntries.length} matching ${visibleEntries.length === 1 ? "player" : "players"}. ${playerCountLabel(leaderboardTotalPlayers)} total on the board.`
    : `${playerCountLabel(leaderboardTotalPlayers)} on the shared board.`;

  leaderboardBody.innerHTML = visibleEntries
    .map((entry) => `
      <tr>
        <td><span class="board-place">${entry.place}</span>${escapeHtml(entry.name)}</td>
        ${entry.scores.map((score) => `<td>${score}</td>`).join("")}
        <td><strong>${entry.total}</strong><small>${escapeHtml(entry.rank)}</small></td>
      </tr>
    `)
    .join("");
}

async function loadBoard({ announce = false, query = leaderboardSearch.value.trim() } = {}) {
  const requestNumber = ++boardRequestNumber;
  leaderboardLoading = true;
  leaderboardError = "";
  renderBoard();

  try {
    const url = new URL(leaderboardApiUrl);
    if (query) url.searchParams.set("q", query);
    const response = await fetch(url, {
      headers: { Accept: "application/json" },
      cache: "no-store",
    });
    const payload = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(payload.error || "The live leaderboard could not be loaded.");
    }
    if (requestNumber !== boardRequestNumber) return false;

    leaderboardEntries = Array.isArray(payload.entries) ? payload.entries : [];
    leaderboardTotalPlayers = Number.isInteger(payload.totalPlayers)
      ? payload.totalPlayers
      : leaderboardEntries.length;
    loadedSearchQuery = query;
    if (announce) {
      challengeMessage.textContent = `Live scores refreshed. ${playerCountLabel(leaderboardTotalPlayers)} on the board.`;
    }
    return true;
  } catch (error) {
    if (requestNumber !== boardRequestNumber) return false;
    leaderboardError = error.message || "The live leaderboard could not be loaded.";
    if (announce) challengeMessage.textContent = leaderboardError;
    return false;
  } finally {
    if (requestNumber === boardRequestNumber) {
      leaderboardLoading = false;
      renderBoard();
    }
  }
}

eventInputs.forEach((input) => {
  input.addEventListener("input", updateChallengeTotal);
  input.addEventListener("blur", () => {
    input.value = clampScore(input.value);
    updateChallengeTotal();
  });
});

challengeForm.addEventListener("submit", async (event) => {
  event.preventDefault();
  const name = playerName.value.trim();

  if (!name) {
    challengeMessage.textContent = "Enter a player name before posting the score.";
    playerName.focus();
    return;
  }

  const scores = currentScores();
  eventInputs.forEach((input, index) => { input.value = scores[index]; });
  const originalButtonText = scoreSubmitButton.textContent;
  scoreSubmitButton.disabled = true;
  scoreSubmitButton.textContent = "Posting score...";
  challengeMessage.textContent = "Posting your score to the live board...";

  try {
    const response = await fetch(leaderboardApiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        name,
        playerId: getPlayerId(),
        scores,
        website: scoreHoneypot.value,
      }),
    });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) {
      throw new Error(payload.error || "The score could not be posted.");
    }

    leaderboardSearch.value = "";
    const boardLoaded = await loadBoard({ query: "" });
    challengeMessage.textContent = boardLoaded
      ? payload.message
      : `${payload.message} Refresh the board to see the latest ranking.`;
  } catch (error) {
    challengeMessage.textContent = error.message || "The score could not be posted. Try again.";
  } finally {
    scoreSubmitButton.disabled = false;
    scoreSubmitButton.textContent = originalButtonText;
  }
});

refreshBoardButton.addEventListener("click", () => loadBoard({ announce: true }));

leaderboardSearch.addEventListener("input", () => {
  window.clearTimeout(boardSearchTimer);
  renderBoard();
  boardSearchTimer = window.setTimeout(() => {
    loadBoard({ query: leaderboardSearch.value.trim() });
  }, 250);
});

if (reviewTickerTrack && reviewTickerGroup) {
  const duplicateReviews = reviewTickerGroup.cloneNode(true);
  duplicateReviews.setAttribute("aria-hidden", "true");
  duplicateReviews.removeAttribute("role");
  duplicateReviews.querySelectorAll("[role]").forEach((element) => element.removeAttribute("role"));
  reviewTickerTrack.append(duplicateReviews);
}

if (customerVideos.length) {
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const updateVideoPlayback = (video, isVisible) => {
    if (isVisible && video.hasAttribute("data-autoplay") && !reducedMotion.matches) {
      video.play().catch(() => {});
    } else if (!isVisible) {
      video.pause();
    }
  };

  customerVideos.forEach((video) => {
    video.addEventListener("play", () => {
      customerVideos.forEach((otherVideo) => {
        if (otherVideo !== video) otherVideo.pause();
      });
    });
  });

  if ("IntersectionObserver" in window) {
    const videoObserver = new IntersectionObserver(
      (entries) => entries.forEach((entry) => updateVideoPlayback(entry.target, entry.isIntersecting)),
      { threshold: 0.4 },
    );
    customerVideos.forEach((video) => videoObserver.observe(video));
  } else if (!reducedMotion.matches) {
    customerVideos.forEach((video) => {
      if (video.hasAttribute("data-autoplay")) video.play().catch(() => {});
    });
  }
}

if (customerVideoCarousel && customerVideoSlides.length && customerVideoSwitches.length) {
  let videoScrollFrame;
  const setActiveVideo = (activeIndex) => {
    customerVideoSwitches.forEach((button, index) => {
      const isActive = index === activeIndex;
      button.classList.toggle("is-active", isActive);
      button.setAttribute("aria-pressed", String(isActive));
    });
  };

  const currentVideoIndex = () => {
    const carouselRect = customerVideoCarousel.getBoundingClientRect();
    const carouselCentre = carouselRect.left + carouselRect.width / 2;
    let closestIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    customerVideoSlides.forEach((slide, index) => {
      const slideRect = slide.getBoundingClientRect();
      const distance = Math.abs(slideRect.left + slideRect.width / 2 - carouselCentre);
      if (distance < closestDistance) {
        closestIndex = index;
        closestDistance = distance;
      }
    });

    return closestIndex;
  };

  customerVideoSwitches.forEach((button) => {
    button.addEventListener("click", () => {
      const targetIndex = Number(button.dataset.customerVideoTarget);
      const targetSlide = customerVideoSlides[targetIndex];
      if (!targetSlide) return;

      const carouselRect = customerVideoCarousel.getBoundingClientRect();
      const slideRect = targetSlide.getBoundingClientRect();
      customerVideoCarousel.scrollTo({
        left: customerVideoCarousel.scrollLeft + slideRect.left - carouselRect.left,
        behavior: "smooth",
      });
      setActiveVideo(targetIndex);
      customerVideos.forEach((video, index) => {
        if (index !== targetIndex) video.pause();
      });
    });
  });

  customerVideoCarousel.addEventListener(
    "scroll",
    () => {
      window.cancelAnimationFrame(videoScrollFrame);
      videoScrollFrame = window.requestAnimationFrame(() => setActiveVideo(currentVideoIndex()));
    },
    { passive: true },
  );
}

const shopifyOrderForm = document.querySelector("#ShopifyOrderForm");
const popperQty = document.querySelector("#popperQty");
const ballQty = document.querySelector("#ballQty");
const subtotal = document.querySelector("#subtotal");
const orderButton = document.querySelector("#orderButton");
const orderNote = document.querySelector("#orderNote");
const money = new Intl.NumberFormat("en-CA", {
  style: "currency",
  currency: "CAD",
  currencyDisplay: "narrowSymbol",
});

function boundedNumber(input) {
  if (!input) return 0;
  const min = Number(input.min || 0);
  const max = Number(input.max || 99);
  const value = Number(input.value || min);
  return Math.min(Math.max(value, min), max);
}

function updateSubtotal() {
  if (!popperQty || !subtotal) return { poppers: 0, ballSets: 0, total: 0 };

  const poppers = boundedNumber(popperQty);
  const ballSets = boundedNumber(ballQty);
  const trainerPrice = Number(popperQty.dataset.unitPrice || 0) / 100;
  const trainingBallPrice = Number(ballQty?.dataset.unitPrice || 0) / 100;
  popperQty.value = poppers;
  if (ballQty) ballQty.value = ballSets;
  const total = poppers * trainerPrice + ballSets * trainingBallPrice;
  subtotal.textContent = `${money.format(total)} CAD`;
  return { poppers, ballSets, total };
}

async function addItemsToShopifyCart(items) {
  const root = window.Shopify?.routes?.root || "/";
  const response = await fetch(`${root}cart/add.js`, {
    method: "POST",
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ items }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.description || "The order could not be added to the cart.");
  }

  return root;
}

async function handleQuickCheckout(event) {
  if (
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    event.button !== 0
  ) {
    return;
  }

  event.preventDefault();
  const button = event.currentTarget;
  if (button.dataset.checkoutLoading === "true") return;

  const variantId = Number(button.dataset.variantId);
  if (!variantId) {
    window.location.assign(button.href);
    return;
  }

  const originalText = button.textContent;
  button.dataset.checkoutLoading = "true";
  button.setAttribute("aria-disabled", "true");
  button.textContent = "Opening checkout...";

  try {
    const root = await addItemsToShopifyCart([{ id: variantId, quantity: 1 }]);
    window.location.assign(`${root}checkout`);
  } catch {
    button.textContent = originalText;
    button.removeAttribute("aria-disabled");
    delete button.dataset.checkoutLoading;
    window.location.assign(button.href);
  }
}

async function handleShopifyOrder(event) {
  event.preventDefault();
  const order = updateSubtotal();
  const trainerVariant = Number(shopifyOrderForm.querySelector("[name='id']").value);
  const items = [{ id: trainerVariant, quantity: order.poppers }];
  const trainingBallVariant = Number(ballQty?.dataset.variantId || 0);

  if (trainingBallVariant && order.ballSets > 0) {
    items.push({ id: trainingBallVariant, quantity: order.ballSets });
  }

  orderButton.disabled = true;
  orderNote.textContent = "Adding your order to the cart...";
  const originalButtonText = orderButton.textContent;
  orderButton.textContent = "Opening checkout...";

  try {
    const root = await addItemsToShopifyCart(items);
    orderNote.textContent = "Added. Opening secure checkout...";
    window.location.assign(`${root}checkout`);
  } catch (error) {
    orderNote.textContent = error.message;
    orderButton.disabled = false;
    orderButton.textContent = originalButtonText;
  }
}

[popperQty, ballQty].filter(Boolean).forEach((input) => {
  input.addEventListener("input", updateSubtotal);
  input.addEventListener("blur", updateSubtotal);
});

if (shopifyOrderForm) {
  shopifyOrderForm.addEventListener("submit", handleShopifyOrder);
}

quickCheckoutButtons.forEach((button) => {
  button.addEventListener("click", handleQuickCheckout);
});

renderHitterSkills();
updateChallengeTotal();
loadBoard();
if (shopifyOrderForm) updateSubtotal();
